<template>
  <AdminLayout>
    <MainIndex />
    <div class="pb-16"></div>
  </AdminLayout>
</template>

<script>
// @ is an alias to /src
import AdminLayout from '@/layouts/AdminLayout.vue';
import MainIndex from '@/components/admin/businessManagement/MainIndex.vue';

export default {
  name: 'BusinessManagementView',
  components: {
    AdminLayout,
    MainIndex,
  },
};
</script>
